import { render, staticRenderFns } from "./buttom.vue?vue&type=template&id=da0e4db8&scoped=true&"
import script from "./buttom.vue?vue&type=script&lang=js&"
export * from "./buttom.vue?vue&type=script&lang=js&"
import style0 from "./buttom.vue?vue&type=style&index=0&id=da0e4db8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0e4db8",
  null
  
)

export default component.exports